import { Pipe, PipeTransform } from '@angular/core';

/*
 * Formats numbers
 * Takes a string and capitalizes first character
 * Usage:
 *   value | capitalize
 * Example:
 *   {{ 'this is a test' | capitalize }}
 *   formats to: This is a test
 */
@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    const output: string = `${value.charAt(0).toUpperCase()}${value.slice(1)}`;

    return output;
  }
}
